var themesPath = context.path + "/webservices/rest/themes/";
export default {

    getDefaultTheme: function() {
        return $.ajax({
            url: themesPath + "getnew",
            contentType: "application/json",
            method: "GET"
        });
    },

    getThemeById: function(themeId) {
        return $.ajax({
            url: themesPath + "get/" + themeId,
            contentType: "application/json",
            method: "GET"
        });
    },

    getThemeProperties(themeId) {
        return $.ajax({
            url: `${context.path}/webservices/rest/themes/detail`,
            contentType: "application/json",
            data: {themeId}
        });
    }
}
